
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import  themen  from 'theme/styles/styled-colors';
import  * as theme  from 'react-syntax-highlighter/dist/esm/styles/hljs';
import SyntaxHighlighter from 'react-syntax-highlighter';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "apache-atlas-couchbase-bridge"
    }}>{`Apache Atlas Couchbase bridge`}</h1>
    <p>{`This bridge connects to a Couchbase cluster using DCP protocol
and performs real-time analysis and metadata extraction from stored on the cluster documents.
The extracted metadata is then sent to Atlas via its REST API`}</p>
    <h2 {...{
      "id": "configuration"
    }}>{`Configuration`}</h2>
    <p>{`The bridge uses environment variables for configuration.`}</p>
    <h3 {...{
      "id": "atlas-rest-api"
    }}>{`Atlas REST API`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Environment variable`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default Value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`ATLAS_URL`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Atlas REST API url`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"http://localhost:21000"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`ATLAS_USERNAME`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Atlas REST API username`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"admin"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`ATLAS_PASSWORD`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Atlas REST API password`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"admin"`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "couchbase-dcp-connection"
    }}>{`Couchbase DCP connection`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Environment variable`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default Value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`CB_CLUSTER`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Couchbase Cluster connection string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"couchbase://localhost"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`CB_USERNAME`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Couchbase Cluster username`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"Administrator"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`CB_PASSWORD`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Couchbase Cluster password`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"password"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`CB_ENABLE_TLS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Use TLS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`false`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`CB_BUCKET`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Couchbase bucket to monitor`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"default"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`CB_COLLECTIONS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Comma-separated list of collections to monitor with each collection listed as {scope}.{collection}`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`DCP_PORT`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`DCP port to use`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`11210`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`DCP_FIELD_THRESHOLD`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A threshold that indicates in what percentage of analyzed messages per collection  a field must appear before it is sent to Atlas`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`0`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`DCP_SAMPLE_RATIO`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Percentage of DCP messages to be analyzed in form of a short between 0 and 1.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "running-the-bridge"
    }}>{`Running the bridge`}</h2>
    <p>{`In the following commands, replace `}<inlineCode parentName="p">{`<VARNAME>`}</inlineCode>{` and `}<inlineCode parentName="p">{`<version>`}</inlineCode>{` with appropriate values.`}</p>
    <ul>
      <li parentName="ul">{`Set environment variables using `}<inlineCode parentName="li">{`export <VARNAME>=...`}</inlineCode>{` or prefix them before the next command.`}</li>
      <li parentName="ul">{`Run `}<inlineCode parentName="li">{`java -cp couchbase-bridge-<version>.jar com.couchbase.atlas.connector.CouchbaseHook`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Verify that appropriate `}<inlineCode parentName="li">{`couchbase_cluster`}</inlineCode>{`, `}<inlineCode parentName="li">{`couchbase_bucket`}</inlineCode>{` objects were created on your Atlas cluster.`}</li>
      <li parentName="ul">{`After having some documents updated on the Couchbase cluster, verify that appropriate `}<inlineCode parentName="li">{`couchbase_scope`}</inlineCode>{`, `}<inlineCode parentName="li">{`couchbase_collection`}</inlineCode>{`, and `}<inlineCode parentName="li">{`couchbase_field`}</inlineCode>{` objects were created on your Atlas cluster.`}</li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;